<template>
  <div id="pcb-costs-list">
    <!-- <paginated-table :url="url" :columns="columns"></paginated-table> -->
    <Table :loading="loading" highlight-row :data="tableData" :columns="columns" stripe border max-height="600">
      <template slot-scope="{ row, column, index }" slot="propsCell">
        {{ _.get(row, column.key) }}
      </template>
      <template slot-scope="{ row, column, index }" slot="currencyCell">
          {{ intlCurrencyNumber('CNY', _.get(row, column.key), 2, 2) }}
        </template>
    </Table>
  </div>
</template>

<script>
import PaginatedTable from '@/components/tables/paginated-table'
// import tableFields from './pcb-costs-table-fields'
import { intlCurrencyNumber } from '@/libs/util'
import moment from 'moment'
import { mapActions } from 'vuex'
export default {
  name: 'PcbCostsList',
  props: {
    pcbId: {
      type: [String, Number],
      require: true
    }
  },
  components: {
    PaginatedTable
  },
  data () {
    return {
      tableData: [],
      // url: `/pcb/cost-estimates/${this.pcbId}/pcb-cost-calculate-history`,
      columns: [
        {
          title: 'Quantity',
          key: 'quantity'
        },
        {
          title: 'Created',
          key: 'created_at',
          render: (h, params) => {
            return h('div', moment(params.row.created_at).format('YYYY-MM-DD'))
          }
        },
        {
          title: 'Dimension',
          key: 'raw_dimension',
          render: (h, params) => {
            return h('div', params.row.height + 'x' + params.row.width + 'mm/piece')
          }
        },
        {
          title: 'Std. lead time',
          key: 'std_lead_time',
          render: (h, params) => {
            return h('div', params.row.std_lead_time + ' working days')
          }
        },
        {
          title: 'Urgency days',
          key: 'urgency_days',
          render: (h, params) => {
            var days = params.row.urgency_days + ' working days'
            return h('div', days)
          }
        },
        {
          title: 'Impedance test',
          key: 'impedance_test',
          render: (h, params) => {
            return h('div', params.row.impedance_test ? 'Yes' : 'No')
          }
        },
        {
          title: 'Service fee',
          key: 'service_fee',
          render: (h, params) => {
            return h('div', intlCurrencyNumber('CNY', params.row.service_fee, 2, 2))
          }
        },
        {
          title: 'Express fee',
          key: 'express_fee',
          render: (h, params) => {
            return h('div', intlCurrencyNumber('CNY', params.row.express_fee, 2, 2))
          }
        },
        {
          title: 'Board cost',
          key: 'board_cost',
          render: (h, params) => {
            return h('div', intlCurrencyNumber('CNY', params.row.board_cost, 2, 2))
          }
        },
        {
          title: 'Urgency fee',
          key: 'urgency_fee',
          render: (h, params) => {
            return h('div', intlCurrencyNumber('CNY', params.row.urgency_fee, 2, 2))
          }
        },
        {
          title: 'Total cost',
          key: 'total_cost',
          render: (h, params) => {
            return h('div', intlCurrencyNumber('CNY', params.row.total_cost, 2, 2))
          }
        },
        {
          title: 'Action',
          render: (h, params) => {
            let linkClick = {
              on: {
                click: () => {
                  let editRouter = this.$router.resolve({
                    name: 'menu.estimators.pcb_cost',
                    params: {
                      pcbCostId: params.row.id
                    }
                  })
                  window.open(editRouter.href, '_blank')
                }
              }
            }
            return h('a', linkClick, 'Edit')
          }
        }
      ],
      loading: false
    }
  },
  mounted () {
    this.loading = true
    this.getCalculateHistory(this.pcbId).then(res => {
      this.loading = false
      this.tableData = res.data.data
    }).finally(() => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions([
      'getCalculateHistory'
    ]),
    intlCurrencyNumber
  }
}
</script>

<style>

</style>
